import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../lib/supabaseClient';
import { LIVE } from '../../lib/queryPresets';

export interface CollaboratorActivity {
  collaborator_id: string;
  last_login_at: string | null;
  last_seen_at: string | null;
  seconds_today: number;
  seconds_last7: number;
}

/**
 * Synthèse d'activité (dernière connexion + temps de présence) par collaborateur.
 * RPC réservée aux admins (la fonction SQL renvoie un set vide sinon).
 * Activé uniquement quand `enabled` (= utilisateur admin) pour éviter un appel inutile.
 */
export function useCollaboratorActivity(enabled: boolean) {
  return useQuery({
    ...LIVE, // synthèse partagée entre admins, pas de Realtime dessus
    queryKey: ['collaborator-activity'],
    enabled,
    queryFn: async (): Promise<Record<string, CollaboratorActivity>> => {
      const { data, error } = await supabase.rpc('get_collaborator_activity');
      if (error) throw error;
      const byId: Record<string, CollaboratorActivity> = {};
      for (const row of (data ?? []) as CollaboratorActivity[]) {
        byId[row.collaborator_id] = row;
      }
      return byId;
    },
  });
}
